import { useEffect, useRef } from 'react'
import { PAYMENT_SUCCESS } from '../../constants/payment'
import appUserService from '../../services/appUserService'

const DEFAULT_INTERVAL_MS = 5000

/**
 * Polling trang thai thanh toan cua mot order trong khi QR dang hien thi.
 *
 * Hook nay chi lam mot viec: dinh ky goi `getOrderDetail` va trigger `onSuccess`
 * khi `paymentStatus === Success`. Viec dieu huong / dong modal QR do call site
 * tu xu ly trong callback de giu hook generic.
 *
 * @param {Object} options
 * @param {number|string|null|undefined} options.orderId - Order id can theo doi.
 * @param {boolean} options.enabled - Co bat polling hay khong (vd QR dang mo).
 * @param {(payload: { orderId: number|string, orderDetail: any }) => void} options.onSuccess
 * @param {number} [options.intervalMs=5000] - Khoang thoi gian giua moi lan goi.
 */
export default function useTrafficFineOrderPaymentPolling({
  orderId,
  enabled,
  onSuccess,
  intervalMs = DEFAULT_INTERVAL_MS
} = {}) {
  // Giu reference moi nhat de effect khong setup lai moi khi callback doi.
  const onSuccessRef = useRef(onSuccess)

  useEffect(() => {
    onSuccessRef.current = onSuccess
  }, [onSuccess])

  useEffect(() => {
    if (!enabled || !orderId) {
      return undefined
    }

    let isActive = true

    const checkOrderStatus = async () => {
      try {
        const response = await appUserService.getOrderDetail({ id: orderId })

        if (!isActive) {
          return
        }

        if (response?.statusCode === 200 && response?.data?.paymentStatus === PAYMENT_SUCCESS) {
          if (typeof onSuccessRef.current === 'function') {
            onSuccessRef.current({
              orderId,
              orderDetail: response.data
            })
          }
        }
      } catch {
        // Loi mang/timeout tam thoi cu de vong polling tiep theo thu lai.
      }
    }

    // Goi ngay lan dau roi moi setInterval, khop voi behavior cu.
    checkOrderStatus()
    const intervalId = setInterval(checkOrderStatus, intervalMs)

    return () => {
      isActive = false
      clearInterval(intervalId)
    }
  }, [enabled, intervalMs, orderId])
}
